<template>
  <base-social
    mode="social-homepage"
    :share-url="shareUrl"
    :icon-class="iconClass"
    :button-class="buttonClass"
  >
  </base-social>
  <language-button></language-button>

  <div class="main" :lang="getLanguage">
    <router-link to="/about">
      <img class="logo" src="/img/logo/lupa_wave_col.png" />
    </router-link>

    <div class="content">
      <div
        @click="goToPage(page.position)"
        v-for="page in pageLinks"
        :key="page"
        class="component"
        :class="page.position"
      >
        <picture class="component-picture">
          <source
            media="(width <= 425px)"
            :srcset="page[getLanguage].src_phone"
          />
          <source
            media="(width <= 768px)"
            :srcset="page[getLanguage].src_tablet"
          />
          <source
            media="(width > 768px)"
            :srcset="page[getLanguage].src_desk"
          />
          <img
            src="/img/homepage/en_minerals_desktop.png"
            alt="link to minerals page"
            class="picture-img"
          />
        </picture>
        <div class="component-heading">{{ page[getLanguage].heading }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { useSeoMeta } from "@unhead/vue";

/** Data */
const store = useStore();
const router = useRouter();

const pageLinks = ref({
  mineral: {
    en: {
      heading: "search for minerals",
      src_phone: "/img/homepage/en_minerals_phone.webp",
      src_tablet: "/img/homepage/en_minerals_tablet.webp",
      src_desk: "/img/homepage/en_minerals_desktop.webp",
    },
    pt: {
      heading: "saiba mais sobre minerais",
      src_phone: "/img/homepage/pt_minerals_phone.webp",
      src_tablet: "/img/homepage/pt_minerals_tablet.webp",
      src_desk: "/img/homepage/pt_minerals_desktop.webp",
    },
    position: "component-left",
  },
  rock: {
    en: {
      heading: "search for rocks",
      src_phone: "/img/homepage/en_rocks_phone.webp",
      src_tablet: "/img/homepage/en_rocks_tablet.webp",
      src_desk: "/img/homepage/en_rocks_desktop.webp",
    },
    pt: {
      heading: "saiba mais sobre rochas",
      src_phone: "/img/homepage/pt_rocks_phone.webp",
      src_tablet: "/img/homepage/pt_rocks_tablet.webp",
      src_desk: "/img/homepage/pt_rocks_desktop.webp",
    },
    position: "component-right",
  },
});

// Social buttons
const shareUrl = ref({
  title: "lupanalua",
  text: "A website about the nature around us",
  url: "https://www.lupanalua.com",
});

const buttonClass = {
  basic: "social--action-home",
};
const iconClass = {
  basic: "icon--home-basic",
};

useSeoMeta({
  title: "Search for minerals and rocks | lupanalua",
  ogTitle: "lupanalua",
  ogType: "website",
  ogUrl: "https://www.lupanalua.com",
});

// computed

/**
 * @returns {String} of the user language
 */
const getLanguage = computed(() => {
  return store.getters.getCurrentLanguage;
});

// method

function goToPage(value) {
  if (value.includes("left")) return router.push("/minerals");
  return router.push("/rocks");
}
</script>
<style scoped>
.logo {
  width: 8rem;
  height: 8rem;
  position: fixed;
  top: 5rem;
  left: 5rem;
  z-index: 2000;
}

.main {
  width: 100vw;
  height: 100vh;
  background-color: #ffffff;
  background-image: linear-gradient(#eee 0.1em, transparent 0.1em);
  background-size: 100% 1.2em;

  display: grid;
  grid-template-columns: [left-start] 10% [left-end content-start] 80% [content-end right-start]10%[right-end];
  grid-template-rows: 20% 70% 10%;
}
@media only screen and (max-width: 1024px) {
  .logo {
    top: 3rem;
    left: 3rem;
  }
  .main {
    grid-template-columns: [left-start] 2% [left-end content-start] 96% [content-end right-start]2%[right-end];
    grid-template-rows: 12% 80% 8%;
  }
}

.content {
  grid-column: content-start/content-end;
  grid-row: 2/3;
  display: flex;
}

.component {
  box-shadow: 5px 5px 2px 1px var(--color-primary-1);
  border: 1px solid var(--color-primary-3);
  border-radius: 30px;
  max-width: 100%;
  max-height: 80%;
  cursor: pointer;
  padding: 1px 1px 3rem 1px;
  margin: 2rem;
  background-color: white;
  display: grid;
  grid-template-rows: 90% 10%;
}
.component:hover {
  border: 5px solid var(--color-primary-3);
  border-style: dashed;
}
@media only screen and (max-width: 768px) {
  .component {
    margin: 0.7rem;
  }
}
.component-left {
  grid-row: 2 / 3;
}

.component-right {
  grid-row: 2 / 3;
}
/* 768px */
@media only screen and (max-width: 48em) {
  .component-left {
    grid-column: center-start / center-end;
    grid-row: 2 / 3;
  }

  .component-right {
    grid-column: center-start / center-end;
    grid-row: 3 / 4;
  }
}

.component-picture {
  grid-row: 1/2;
  border-radius: 30px 30px 0 0;
}

.picture-img {
  border-radius: 30px 30px 0 0;
  width: 100%;
  /* max-width: 480px; */
  /* max-height: 360px; */
  min-height: 90%;
  object-fit: cover;
}

/* 768px */
@media only screen and (max-width: 768px) {
  .picture-img {
    max-width: 360px;
  }
}

.component-heading {
  max-height: 20%;
  text-align: center;
  font-size: 3rem;
  font-family: var(--font-display);
  text-transform: uppercase;
  color: var(--color-grey-4);
  background-color: rgb(252, 255, 240);
  border-radius: 0 0 10px 10px;
  grid-row: 2/3;
}

.page {
  grid-column: right-start/right-end;
  grid-row: 2 / 3;
  width: 15vw;
  margin-left: -3rem;
  margin-top: 20%;
  transition: all 0.3s ease-in;
}

.scroll-page {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 300px;
}

.active {
  display: block;
}
.inactive {
  display: none;
}
</style>
